(() => {
  'use strict';
  const instances = new Map();
  function initialize(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const listen = (target, type, callback) => target.addEventListener(type, callback, { signal: controller.signal });
    const $ = id => root.querySelector('[id="tdbf-' + id + '"]');
    const text = root.dataset;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const endAt = Date.parse('2026-12-04T23:59:59-08:00');
    const productUrls = [text.productOne, text.productTwo];
    const collectionUrls = [text.collectionOne, text.collectionTwo];
    const titles = [text.titleOne, text.titleTwo];
    const descriptions = [text.descriptionOne, text.descriptionTwo];
    const photoLabels = [text.photoOneLabel, text.photoTwoLabel];
    const buttons = [...root.querySelectorAll('[data-slide]')];
    let current = 0, paused = motion.matches, autoplay, captionTimer, unused;
    function safeUrl(value) {
      try { const parsed = new URL(value, window.location.origin); return ['http:', 'https:'].includes(parsed.protocol) && !parsed.username && !parsed.password ? parsed.href : ''; } catch { return ''; }
    }
    function links() {
      const product = safeUrl(productUrls[current]);
      ['photo-link', 'product-cta'].forEach(id => {
        const element = $(id);
        element.hidden = !product;
        if (product) element.setAttribute('href', product); else element.removeAttribute('href');
        element.setAttribute('aria-label', photoLabels[current]);
      });
      $('shop-cta').setAttribute('href', safeUrl(collectionUrls[current]) || '/collections/all');
    }
    function showSlide(index) {
      const next = (index + 2) % 2;
      if (next !== current && !motion.matches) {
        clearTimeout(captionTimer);
        $('event').classList.add('td-bf-switching');
        captionTimer = setTimeout(() => $('event').classList.remove('td-bf-switching'), 650);
      }
      current = next;
      buttons.forEach((button, i) => {
        $('scene-' + i).classList.toggle('td-bf-active', i === current);
        button.classList.toggle('td-bf-selected', i === current);
        button.setAttribute('aria-pressed', String(i === current));
      });
      $('scene-number').textContent = String(current + 1).padStart(2, '0');
      $('slide-count').textContent = '0' + (current + 1) + ' / 02';
      $('scene-title').textContent = titles[current];
      $('scene-description').textContent = descriptions[current];
      links();
    }
    function schedule() {
      clearInterval(autoplay);
      if (!paused && !document.hidden) autoplay = setInterval(() => showSlide(current + 1), 7500);
    }
    function setPaused(value) {
      paused = value;
      $('pause').textContent = '';
      $('pause').setAttribute('aria-label', paused ? text.playLabel : text.pauseLabel);
      $('pause').setAttribute('aria-pressed', String(paused));
      $('event').classList.toggle('td-bf-paused', paused);
      schedule();
    }
    function countdown() {
      const remaining = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      ['days', 'hours', 'minutes', 'seconds'].forEach((id, i) => $(id).textContent = String(values[i]).padStart(2, '0'));
      $('countdown').hidden = remaining === 0;
      $('ended').hidden = remaining !== 0;
      $('countdown-title').textContent = remaining === 0 ? text.eventLabel : text.endsLabel;
    }
    listen($('pause'), 'click', () => setPaused(!paused));
    listen($('prev'), 'click', () => { showSlide(current - 1); schedule(); });
    listen($('next'), 'click', () => { showSlide(current + 1); schedule(); });
    buttons.forEach((button, i) => listen(button, 'click', () => { showSlide(i); schedule(); }));
    listen(document, 'visibilitychange', schedule);
    listen(motion, 'change', event => { if (event.matches) setPaused(true); });
    ['photo-link', 'product-cta', 'shop-cta'].forEach(id => {
      listen($(id), 'pointerenter', () => clearInterval(autoplay));
      listen($(id), 'pointerleave', schedule);
      listen($(id), 'focus', () => clearInterval(autoplay));
      listen($(id), 'blur', schedule);
    });
    root.querySelectorAll('.td-bf-glass').forEach(card => {
      listen(card, 'pointermove', event => {
        if (motion.matches || event.pointerType !== 'mouse') return;
        const r = card.getBoundingClientRect();
        card.style.setProperty('--px', ((event.clientX - r.left) / r.width * 100) + '%');
        card.style.setProperty('--py', ((event.clientY - r.top) / r.height * 100) + '%');
      });
      listen(card, 'pointerleave', () => { card.style.removeProperty('--px'); card.style.removeProperty('--py'); });
    });
    function reserveHeader() {
      const header = document.querySelector('.header-section');
      const top = root.getBoundingClientRect().top + window.scrollY;
      const overlay = header && getComputedStyle(header).position === 'absolute';
      const bottom = overlay ? header.getBoundingClientRect().bottom + window.scrollY : top;
      root.style.setProperty('--td-header-space', Math.max(0, bottom - top) + 'px');
    }
    reserveHeader();
    const headerObserver = new ResizeObserver(reserveHeader);
    const nativeHeader = document.querySelector('.header-section');
    if (nativeHeader) headerObserver.observe(nativeHeader);
    listen(window, 'resize', reserveHeader);
    countdown();
    const clock = setInterval(countdown, 1000);
    showSlide(0);
    setPaused(paused);
    instances.set(root, () => { controller.abort(); headerObserver.disconnect(); clearInterval(clock); clearInterval(autoplay); clearTimeout(captionTimer); });
  }
  function scan(container = document) {
    if (container.matches?.('[data-td-bf-root]')) initialize(container);
    container.querySelectorAll('[data-td-bf-root]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true }); else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
})();
